module.exports = __webpack_public_path__ + "img/logo-three.0c755453.png";